import { IsProd } from "@/constants/config";
import request from "@/utils/request";

const PATH_PREFIX = IsProd ? "/v1/" : "/vb/";

export interface ApiUserSearchHistory {
  cipher_data: true;
  request_time: number;
  type: string;
  query: {
    arrival_airports: string[];
    cabins: string[];
    children: number;
    date_range: {
      from: string;
      to: string;
    };
    return_date_range: {
      from: string;
      to: string;
    };
    departure_airports: string[];
    pax: number;
    programs: string[];
    search_type: string;
    task_ct: number;
  };
}

export const getUserSearchHistory = async () => {
  const res = await request.post<void, { status: number; data: ApiUserSearchHistory[] }>(
    PATH_PREFIX + "user_search_history",
    {}
  );
  return res.data;
};
